
$(function () {
  console.log('Loaded simple script');

  console.log('Loaded simple scriptReal');

  // Initialize each module separately
  $('.productBox').each(function (i) {
    const $root = $(this);

    // Make the radio group name unique per module (prevents cross-selection)
    $root.find('input[type="radio"][name="subscription"]')
      .attr('name', 'subscription_' + i);

    // Helpers to find elements only inside this module
    const $autoRefill = $root.find('#auto_refill');
    const $otpBox = $root.find('.product_box__otp');
    const $subBox = $root.find('.product_box__sub');

    const $origTop = $root.find('#original_total_price');
    const $discTop = $root.find('#discounted-total-price');
    const $saveTop = $root.find('#savings-percentage');

    const $origBot = $root.find('#original-total-price1');
    const $discBot = $root.find('#discounted-total-price1');
    const $saveBot = $root.find('#savings-percentage1');

    function loadTotals() {
      const $selected = ($autoRefill.is(':checked') ? $subBox : $otpBox).find('input:checked');
      if (!$selected.length) return;

      const dataPrice = $selected.attr('data-price') || '';
      const dataCompare = $selected.attr('data-compare') || '';
      const dataSave = ($selected.attr('data-save') || '') + '';

      // NEW: pull the visible "Save ..." text from the selected option card
      const labelSaveText = ($selected
        .closest('.variants-bundles__option')   // the card that wraps this input
        .find('.save')                          // its "Save ..." badge/text
        .first()
        .text() || '')
        .trim();

      $origBot.html('Value: ' + dataCompare);
      $discBot.html('You pay: ' + dataPrice);

      // CHANGED: use the label's save text if present; otherwise fall back to data-save
      $saveBot.html(labelSaveText || ('Save ' + dataSave));

      $origTop.html(dataCompare);
      $discTop.html(dataPrice);
      $saveTop.html(dataSave);

      const hasVisibleSave = !!(labelSaveText || (dataSave !== '0' && dataSave !== ''));
      console.log({ hasVisibleSave, dataSave, labelSaveText, dataCompare, dataPrice });
      [$saveTop, $saveBot, $origTop, $origBot].forEach($el => $el.toggle(hasVisibleSave));
    }


    // Default selections per module
    // If "auto refill" is visible and checked, prefer subscription's middle option (quarterly), else OTP middle (otp2)
    if ($autoRefill.is(':checked')) {
      const picked = $subBox.find('#quarterly');
      if (picked.length) picked.prop('checked', true);
    } else {
      const picked = $otpBox.find('#otp2');
      if (picked.length) picked.prop('checked', true);
    }

    loadTotals();

    // Click any option card to select its radio (scoped to this module)
    $root.on('click', '.variants-bundles__option', function (e) {
      // Avoid double-toggling if clicking the radio directly
      if (!$(e.target).is('input[type="radio"]')) {
        $(this).find('input[type="radio"]').prop('checked', true).trigger('change');
      }
      loadTotals();
    });

    $root.on('click', '.auto-refill', function (e) {
      // If the click was directly on the input, let the browser handle it
      if ($(e.target).is('input')) return;

      const $input = $(this).find('input[type="checkbox"], input[type="radio"]').first();
      if (!$input.length) return;

      if ($input.is(':checkbox')) {
        // checkbox: toggle on/off
        $input.prop('checked', !$input.prop('checked')).trigger('change');
      } else {
        // radio: can only select (not unselect), so only fire if not already checked
        if (!$input.prop('checked')) {
          $input.prop('checked', true).trigger('change');
        }
      }
    });

    // Auto-refill toggle (scoped)
    $autoRefill.on('change', function () {
      $root.find('.variantSelectInput').prop('checked', false);

      if ($(this).is(':checked')) {
        $otpBox.hide();
        $subBox.show();
        const picked = $subBox.find('#quarterly');
        if (picked.length) picked.prop('checked', true);
      } else {
        $otpBox.show();
        $subBox.hide();
        const picked = $otpBox.find('#otp2');
        if (picked.length) picked.prop('checked', true);
      }
      loadTotals();
    });



    // ATC (scoped to a button inside this module, if present)
    $root.on('click', '.atc_btn_main_real', function () {
      console.log('clicked');
      const $checked = $root.find('.variantSelectInput:checked');
      if (!$checked.length) return;

      const currentId = $checked.attr('data-id');
      const sellingPlanId = $checked.attr('data-selling-plan');
      const isAutoRefill = $autoRefill.is(':checked');
      const giftAmount = $checked.attr('data-gift');
      const items = [];

      if (isAutoRefill && sellingPlanId) {
        items.push({ id: currentId, quantity: 1, selling_plan: sellingPlanId });
        if (giftAmount == '1') { items.push({ id: 52403120701750, quantity: 1 }); }
        if (giftAmount == '2') { items.push({ id: 52403120701750, quantity: 1 }); }
        if (giftAmount == '3') { items.push({ id: 52403120505142, quantity: 1 }); items.push({ id: 52403120701750, quantity: 1 }); }
      } else {
        items.push({ id: currentId, quantity: 1 });
        // if (giftAmount == '1') { items.push({ id: 52403384615222, quantity: 1 }); }
        // if (giftAmount == '2') { items.push({ id: 52403384647990, quantity: 1 }); }
      }

      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: { items: items },
        dataType: 'json',
        success: function () {
          if ($('#cart-drawer-kandy').length) {
            window.cart_open && window.cart_open();
            window.cart_build && window.cart_build();
          } else {
            window.location.href = '/cart';
          }
        },
        error: function () { alert('Error adding the items to the cart.'); }
      });
    });
  });
});